import { WsaInteractor } from "./WsaInteractor";
import { WsaApi } from "./WsaApi";
import { WsaPayload } from "../model/WsaPayload";

export class RealWsaInteractor implements WsaInteractor {
  async submit(data: WsaPayload): Promise<void> {
    return WsaApi.submit(data);
  }
}
